import ControllingPolicy from "../../policies/ControllingPolicy.js";
import { useUser } from "@accredo/fe-shared/hooks/user.js";

export function useControllingPermissions() {
  const { user } = useUser();

  return {
    canViewCustomer: (customerId) =>
      ControllingPolicy.viewCustomer({ user, customerId }),
    canViewAny: () => ControllingPolicy.viewAny({ user }),
    canViewAll: () => ControllingPolicy.viewAll({ user }),
    canExportAny: () => ControllingPolicy.exportAny({ user }),
    canExportAll: () => ControllingPolicy.exportAll({ user }),
    canExportCustomer: (customerId) =>
      ControllingPolicy.exportCustomer({ user, customerId }),
  };
}
